<template>
  <div class="main-container" id="caregiver-leave">
    <div class="fixed-float-bar">
      <el-button plain @click="cancelCreateLeave">ยกเลิก</el-button>
      <el-button type="primary" @click="handleLeave" :disabled="select.length === 0">ยืนยัน</el-button>
    </div>
    <el-row class="header">
      <div class="header-36-black">เลือกเวรที่ต้องการลบผู้ดูแล</div>
    </el-row>
    <el-row>
      <el-col :span="1.5">
        <div class="cg-container">
          <div class="circle">
            <img class="fit" v-if="caregiverPhoto" :src="caregiverPhoto" width="60px" height="60px">
            <img v-else src="@/assets/avatar@3x.png" width="60px" height="60px">
          </div>
          <div class="cg-title mar12">{{ caregiverId }}</div>
          <div class="cg-title">{{ caregiverName }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div class="calendar-container">
        <div class="btn-calendar-container">
          <el-button icon="el-icon-arrow-left" @click="goPreviousMonth"></el-button>
          <el-button icon="el-icon-arrow-right" @click="goNextMonth" style="margin-left: 828.768px;"></el-button>
        </div>
        <day-picker-calendar id="calendarLeave" v-model="eventsCalendar" ref="calendarLeave" style="margin: 10px auto 60px auto;" :isAllowAddEvent='false' :maxDate="allowDates.length" :allowDates="allowDates" @select="selectCalendar" typeCalendar='caregiverLeave'/>
      </div>
    </el-row>
    <el-row class="mar16">
      <el-col :span="4">
        <div class="conclude-header">เวรที่ผู้ดูแลลา</div>
      </el-col>
      <el-col :span="3">
        <div class="conclude-number">{{ select.length }} เวร</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="conclude-header">จํานวนเวรที่ทํางาน</div>
      </el-col>
      <el-col :span="3">
        <div class="conclude-number">{{ eventsCalendar.length }} เวร</div>
      </el-col>
    </el-row>

    <!-- Cancel Leave Dialog -->
    <el-dialog :visible.sync="control.showCancelLeaveDialog" :closeOnClickModal="false" :show-close="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการลา ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleCancelClick(false)">ไม่</el-button>
        <el-button type="primary" @click="handleCancelClick(true)">ใช่</el-button>
      </span>
    </el-dialog>

    <!-- Reason For Leave Dialog -->
    <el-dialog :visible.sync="control.showReasonForLeaveDialog" :closeOnClickModal="false" :show-close="false" style="margin-top: 12vh;" width="35%">
      <div style="display: flex; flex-direction: column; align-items: flex-start; margin-top: 30px;">
        <div class="header-18" style="margin-bottom: 9px; font-family: 'Sukhumvit-Bold';">สาเหตุที่ลบเวรผู้ดูแล</div>
        <el-radio v-model="form.reasonTitle" label="cgbreak" style="margin-bottom: 12px;">ผู้ดูแลลา</el-radio>
        <el-radio v-model="form.reasonTitle" label="cgcancel" style="margin-bottom: 12px;">ผู้ดูแลต้องการออกจากเคส</el-radio>
        <el-radio v-model="form.reasonTitle" label="customercancel" style="margin-bottom: 12px;">ลูกค้าต้องการเปลี่ยนผู้ดูแล</el-radio>
        <el-radio v-model="form.reasonTitle" label="other">อื่น ๆ</el-radio>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button :disabled="!form.reasonTitle" type="primary" @click="handleLeaveTitleSelected()">ยืนยัน</el-button>
      </span>
    </el-dialog>

     <!-- Reason Detail Dialog -->
    <el-dialog :visible.sync="control.showReasonDetailDialog" :closeOnClickModal="false" :show-close="false" style="margin-top: 12vh;" width="35%">
      <div style="display: flex; flex-direction: column; align-items: flex-start; margin-top: 30px;">
        <div class="header-18" style="margin-bottom: 9px; font-family: 'Sukhumvit-Bold';">{{reasonDetailHeader}}</div>
        <el-input type="textarea" rows="3" width="65%" v-model="form.reasonDetail" @keydown="inputHandler" />
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button :disabled="form.reasonDetail.trim() === ''" type="primary" @click="handleReasonDetailSubmit()">ยืนยัน</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
  $float-bar: 1000;

  .main-container {
    padding: 155px 100px 160px 100px;
  }

  #caregiver-leave {
    .header-18 {
      font-weight: 500;
      font-size: 18px;
      line-height: 29px;
      color: #434B61;
    }
  }

  .fixed-float-bar {
    z-index: $float-bar;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background-color: white;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .el-row {
    padding-left: 40px;
  }

  .header {
    padding: 40px;
  }

  .cg-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 17px 25px;
    background-color: #f5f7fa;
    border-radius: 8px;
  }

  .circle {
    border-radius: 100%;
    height: 60px;
    width: 60px;
    justify-content: center;
    overflow: hidden;
    margin-right: 25px;
  }

  .fit {
    object-fit: cover;
  }

  .cg-title {
    font-size: 18px;
    font-weight: bold;
    text-align: right;
    color: #909399;
  }

  .mar12 {
    margin-right: 12px;
  }

  .calendar-container {
    margin-top: 55px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 950px;
  }

  .btn-calendar-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
  }

  span.label {
    color: #303133;
    font-size: 18px;
    font-weight: 600;
  }

  .conclude-header {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    font-family: 'Sukhumvit-Bold';
    font-size: 18px;
    font-weight: bold;
    text-align: right;
    color: #303133;
    margin-right: 20px;
  }

  .conclude-number {
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    color: #606266;
  }

  .mar16 {
    margin-bottom: 16px;
  }
</style>

<style lang="scss">
  .fc-widget-content {
    background-color: #eff0f1;
  }
</style>

<script>
import { GenericAPIHandler } from '../shared/GenericAPIHandler'
import DayPickerCalendar from '../shared/DayPickerCalendar'

export default {
  mixins: [GenericAPIHandler],
  mounted () {
    this.prepareCaregiverLeave()
  },
  components: {
    DayPickerCalendar,
  },
  props: {
    reservationId: {
      type: Number,
      required: true,
    },
    patientId: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      caregiverPhoto: '',
      caregiverTitle: '',
      caregiverId: '',
      caregiverName: '',
      eventsCalendar: [],
      allowDates: [],
      select: [],
      control: {
        showCancelLeaveDialog: false,
        showReasonForLeaveDialog: false,
        showReasonDetailDialog: false,
      },
      form: {
        reasonTitle: '',
        reasonDetail: '',
      },
      reasonDetailHeader: '',
    }
  },
  methods: {
    async prepareCaregiverLeave () {
      try {
        const raw = await this.$api.Leave.get(this.id)
        this.caregiverPhoto = raw.caregiver.photoThumb
        this.caregiverTitle = raw.caregiver.title.split(' ')
        this.caregiverId = `${this.caregiverTitle[0]} ${this.caregiverTitle[1]}`
        this.caregiverName = this.caregiverTitle.slice(2, 100).join(' ')
        this.eventsCalendar = [...raw.dates]
        this.allowDates = [...raw.dates]
        this.$refs.calendarLeave.foceUpdateData(raw.dates)
      } catch (error) {
        this.$message.error(error)
      }
    },
    async createLeave () {
      try {
        await this.$api.Leave.leave(this.id, this.select, this.transformToText(this.form.reasonTitle), this.form.reasonDetail)
        this.showSuccessDialog({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    transformToText (reasonTitle) {
      switch (reasonTitle) {
        case 'cgbreak':
          return 'ผู้ดูแลลา'
        case 'cgcancel':
          return 'ผู้ดูแลต้องการออกจากเคส'
        case 'customercancel':
          return 'ลูกค้าต้องการเปลี่ยนผู้ดูแล'
        case 'other':
          return 'อื่นๆ'
      }
    },
    cancelCreateLeave () {
      this.control.showCancelLeaveDialog = true
    },
    handleCancelClick (status) {
      if (status) {
        this.$router.push({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
      }
      this.control.showCancelLeaveDialog = false
    },
    handleLeave () {
      this.control.showReasonForLeaveDialog = true
    },
    handleLeaveTitleSelected () {
      switch (this.form.reasonTitle) {
        case 'cgbreak':
          this.createLeave()
          this.control.showReasonForLeaveDialog = false
          break
        case 'cgcancel':
          this.reasonDetailHeader = 'สาเหตุที่ผู้ดูแลต้องการออกจากเคส'
          this.control.showReasonForLeaveDialog = false
          this.control.showReasonDetailDialog = true
          break
        case 'customercancel':
          this.reasonDetailHeader = 'สาเหตุที่ลูกค้าต้องการเปลี่ยนผู้ดูแล'
          this.control.showReasonForLeaveDialog = false
          this.control.showReasonDetailDialog = true
          break
        case 'other':
          this.reasonDetailHeader = 'สาเหตุอื่น ๆ'
          this.control.showReasonForLeaveDialog = false
          this.control.showReasonDetailDialog = true
          break
        default:
          break
      }
    },
    handleReasonDetailSubmit () {
      this.control.showReasonDetailDialog = false
      this.createLeave()
    },
    inputHandler (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.preventDefault()
        this.form.reasonDetail = `${this.form.reasonDetail}\n`
      }
    },
    selectCalendar (value) {
      // value is  Date that selected and can leave
      this.select.push(value)
    },
    goPreviousMonth () {
      this.$refs.calendarLeave.previousMonth()
    },
    goNextMonth () {
      this.$refs.calendarLeave.nextMonth()
    },
  },
}
</script>
